import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';

// Nastavení ikony markeru
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const MapTestOnClick = () => {
  const [marker, setMarker] = useState(null);
  const [center, setCenter] = useState([50.0755, 14.4378]); // Výchozí souřadnice



  const MapClickHandler = () => {
    useMapEvents({
      click: (event) => {
        const { lat, lng } = event.latlng;
        console.log(lat, lng);
        setMarker({ lat, lng });
       
      },
    });
    return null;
  };

  return (
    <MapContainer center={{lat: '50.465853695710464', lng: '13.40255646608295'}} zoom={13} style={{ height: '100vh', width: '100%' }}>
        <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />

      <MapClickHandler />
      {marker && <Marker position={[marker.lat, marker.lng]} />}
    </MapContainer>
  );
};

export default MapTestOnClick;
